

  export const MenuItems = [
    {   
        icon: <i className="fas fa-globe-americas"></i>,
        title: 'Country',
        url:"/",
        cName: 'nav-links',
    },
    
    
    {   
        icon: <i className="fas fa-heart"></i>,
        title: 'Favorites',
        url:"/favorites",
        cName: 'nav-links',
    },
    {   
        icon: <i className="fas fa-grin-tongue"></i>,
        title: 'About Us',
        url:"/aboutUs",
        cName: 'nav-links',
    },
]